import React, { useState } from 'react';
import {CSSTransition, SwitchTransition} from 'react-transition-group';

import useDidMountEffect from '../custom-hooks/useDidMountEffect';
import StatesList from './StatesList';
import AffiliatesList from './AffiliatesList';
import USMap from './USMap';

import './../scss/FindUs.scss';

function FindUs({
    affiliates,
    network,
    hideSelectOnResults,
    autoScrollOffset
}) {
    const [stateId, setStateId] = useState('');
    const [viewResults, setViewResults] = useState(false);

    const resultsListSelector = '.find-us__results'

    /**
     * A custom hook that's not fired on the
     * initial load
     */
    useDidMountEffect(() => {
       toggleResultsView();
    }, [stateId]);  
    
    // event handlers ====

    /**
     * Updates the stateId when a new one is selected
     * 
     * @param {the state id value} abbr 
     * @param {the event responsible for the update} e 
     */
    function stateSelected(abbr, e) {
        setStateId(abbr);
    };

    /**
     * Handles toggling the results list
     */
    function toggleResultsView() {
        if (hideSelectOnResults) {
            setViewResults(!viewResults);
        } else {
            if (!viewResults) setViewResults(true);
            scrollToResults();
        }
    }
    
    // helper functions ====

    /**
     * Scrolls the results list into view 
     */
    function scrollToResults() {  
        setTimeout(() => {
            let el;
            if (el = document.querySelector(resultsListSelector)) {              
                window.scroll({
                    left: 0, 
                    top: (el.getBoundingClientRect().y + window.pageYOffset) -  autoScrollOffset,
                    behavior: 'smooth',
                });
            }
        }, 100);   
    }

    // render ====

    if (hideSelectOnResults) {
        return (
            <section className="find-us"> 
                <SwitchTransition mode="out-in">
                    <CSSTransition
                        key={viewResults}
                        timeout={350}
                        onExited={scrollToResults}
                        classNames="fade"
                    >                    
                        {viewResults ? 
                            <div className="find-us__results">
                                <AffiliatesList 
                                    toggleResultsView={toggleResultsView} 
                                    stateId={stateId} 
                                    setStateId={setStateId}
                                    affiliates={affiliates} 
                                    network={network} 
                                    hideSelectOnResults={hideSelectOnResults} 
                                />
                            </div>
                            :
                            <div className="find-us__selector constrain-content">
                                <USMap 
                                    stateSelectedHandler={stateSelected} 
                                    stateId={stateId} 
                                    hideSelectOnResults={hideSelectOnResults}
                                />
                                <StatesList 
                                    stateSelectedHandler={stateSelected} 
                                    stateId={stateId}
                                />
                            </div>                     
                        }                
                    </CSSTransition>
                </SwitchTransition>
            </section>
        );
    } else {
        return (
            <section className="find-us">
                <div className="find-us__selector constrain-content">
                    <USMap 
                        stateSelectedHandler={stateSelected} 
                        stateId={stateId} 
                        hideSelectOnResults={hideSelectOnResults}
                    />
                    <StatesList 
                        stateSelectedHandler={stateSelected} 
                        stateId={stateId} 
                    />
                </div>
                <div className="find-us__ad-wrapper">
                    <div className="find-us__img find-us__ad--mobile">
                        <a href="https://www.thefreetvproject.org/scan/?utm_campaign=digital_networks_scan_ionplus&utm_source=website&utm_medium=static" 
                            title="Learn how to get more free channels on your TV"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src="https://ewscripps-brightspot-lower.s3.amazonaws.com/b8/8c/9c4264b142e08fd3511789b8b017/psc-53177-networks-rescan-ads-r5-a-300x250.png" alt="Love finding more free channels? Rescan your TV to get new channels with your atenna. Learn How Here" />
                        </a>
                    </div>
                    <div className="find-us__img">
                        <a href="https://www.thefreetvproject.org/scan/?utm_campaign=digital_networks_scan_ionplus&utm_source=website&utm_medium=static" 
                            title="Learn how to get more free channels on your TV"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img src="https://ewscripps-brightspot-lower.s3.amazonaws.com/5c/23/0bfec9b548898f5c90b03c4d3254/psc-53177-networks-rescan-ads-r5-a-728x90.png" alt="Love finding more free channels? Rescan your TV to get new channels with your atenna. Learn How Here" style={{border: '1px solid #444'}} />
                        </a>
                    </div>
                </div>
                <CSSTransition
                    in={viewResults}
                    timeout={1000}
                    classNames="fade-slow"
                >       
                    <div className="find-us__results">
                        { (viewResults) &&                         
                            <AffiliatesList 
                                toggleResultsView={toggleResultsView} 
                                stateId={stateId} 
                                setStateId={setStateId}
                                affiliates={affiliates} 
                                network={network} 
                                hideSelectOnResults={hideSelectOnResults} 
                            />
                        }
                    </div>
                </CSSTransition>
            </section>
        );
    }
}

export default FindUs;
